import { render, staticRenderFns } from "./layout-invisible.vue?vue&type=template&id=35245ab6&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johndwells/Git/hys/penge-polls/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35245ab6')) {
      api.createRecord('35245ab6', component.options)
    } else {
      api.reload('35245ab6', component.options)
    }
    module.hot.accept("./layout-invisible.vue?vue&type=template&id=35245ab6&", function () {
      api.rerender('35245ab6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vue/layouts/layout-invisible.vue"
export default component.exports